<template>
    <v-row dense>
        <v-col cols="12" md="4">
            <v-text-field
                v-model="search"
                variant="outlined"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                density="comfortable"
                solo
                hide-details
                rounded="lg"
                color="primary"
            ></v-text-field>
        </v-col>
        <v-col class="d-flex flex-column flex-md-row justify-end ga-md-2" cols="12" md="8">
            <v-btn @click="showCopyProgramOutcomesDialog()" prepend-icon="mdi-content-copy" class="mt-1 rounded-lg" color="green"
                height="40px" elevation="2">
                Copy from Previous Semester
            </v-btn>
            <v-btn @click="showAddDialog()" prepend-icon="mdi-plus" class="mt-1 rounded-lg" color="routesColor"
                height="40px" elevation="2">
                Add Program Outcomes
            </v-btn>
        </v-col>
        <v-col cols="12">
            <v-card class="dt-container mt-2">
                <v-data-table :mobile="isMobileOrTablet()" :headers="headers" :items="data" :search="search"
                    :loading="loading" :items-per-page="15" :items-per-page-options="[5, 10, 15, 20, -1]">
                    <template v-slot:loading>
                        <v-progress-linear indeterminate color="primary" height="5"
                            class="mt-1 rounded-lg"></v-progress-linear>
                    </template>
                    <template v-slot:item.description="{ item }">
                        <div class="text-truncate" style="max-width: 600px;">{{ item.description }}</div>
                    </template>
                    <template v-slot:item.datecreated="{ item }">
                        <span>{{ formatDateTime(item.datecreated) }} </span>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <div class="d-flex justify-end ga-2">
                            <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit"
                                color="orange" elevation="3"></v-btn>
                            <v-btn @click="showDeleteDialog(item)" size="small" variant="outlined"
                                text="Remove" color="red" elevation="3"></v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="white" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to remove this program outcome?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, this action cannot be reversed.</div>
            </v-card-text>
            <template v-slot:actions>
                <v-spacer></v-spacer>
                <v-btn @click="confirmDelete = false" :disabled="loadingConfirmation" variant="outlined">
                    Cancel
                </v-btn>
                <v-btn :loading="loadingConfirmation" @click="deleteOutcome()" color="red" variant="elevated">
                    Confirm
                </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <ProgramOutcomesDialog ref="ProgramOutcomesDialog" @refresh="initData(program)" />
    <CopyProgramOutcomesDialog ref="CopyProgramOutcomesDialog" @refresh="initData(program)" />
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import ProgramOutcomesDialog from '../Dialogs/ProgramOutcomesDialog.vue';
import CopyProgramOutcomesDialog from '../Dialogs/Sub-Dialogs/CopyProgramOutcomesDialog.vue';

export default defineComponent({
    components: {
        ProgramOutcomesDialog,
        CopyProgramOutcomesDialog
    },
    data () {
        return {
            loading: false,
            search: null,
            data: [],
            program: null,
            headers: [
                { title: 'Code', align: 'start', sortable: true, key: 'code' },
                { title: 'Description', align: 'start', sortable: true, key: 'description' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
            confirmDelete: false,
            itemToDelete: null,
            loadingConfirmation: false,
        }
    },
    methods: {
        async initData(data){
            this.loading = true
            this.program = data
            let res = await this.axiosCall('/program-outcomes/findAllByProgramId/' + data.id + '/' + this.$store.state.semester_schoolyear.id, 'get', null, true)
            if (res.data) {
                this.data = res.data
                this.loading = false
            }
        },
        async deleteOutcome() {
            const { showSnackbar } = useSnackbar();
            this.loadingConfirmation = true;
            let res = await this.axiosCall(`/program-outcomes/${this.itemToDelete.id}`, 'delete', null, true)
            if (res.data) {
                this.loadingConfirmation = false;
                showSnackbar('Program outcome successfully removed!');
                this.confirmDelete = false;
                this.initData(this.program);
            }
        },
        showAddDialog() {
            this.$refs.ProgramOutcomesDialog.initAdd()
        },
        showEditDialog(data) {
            this.$refs.ProgramOutcomesDialog.initEdit(data)
        },
        showDeleteDialog(data) {
            this.itemToDelete = data
            this.confirmDelete = true
        },
        showCopyProgramOutcomesDialog() {
            this.$refs.CopyProgramOutcomesDialog.init(this.program)
        },
    }
})
</script>

<style scoped>

</style>